import { render, staticRenderFns } from "./DropdownSelect.vue?vue&type=template&id=4d55a765&scoped=true"
import script from "./DropdownSelect.vue?vue&type=script&lang=js"
export * from "./DropdownSelect.vue?vue&type=script&lang=js"
import style0 from "./DropdownSelect.vue?vue&type=style&index=0&id=4d55a765&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d55a765",
  null
  
)

export default component.exports